











































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DropDownMulitiple extends Vue { 
    @Prop(Array) readonly items: any
    @Prop() public changeState: any
    @Prop(String) readonly label!: string
    @Prop(String) readonly itemText!: string
    @Prop(String) readonly itemValue!: string
    @Prop(String) readonly keyName!: string
    @Prop({ type: Boolean, default: true }) readonly multiple!: boolean

	selectedValue = null as any

	updateState () {
		const textField = this.itemText || 'name'
		const valueField = this.itemValue || 'id'
		const key = this.keyName || 'selectedIds'
		
		if (this.multiple) {
			// Multi-select mode
			if (this.selectedValue !== null && Array.isArray(this.selectedValue)) {
				const values = this.selectedValue.map((x: any) => x[valueField])
				this.changeState(key, values)
				this.$emit('change', { key: key, value: values })
				this.$emit('update:modelValue', this.selectedValue)
			} else {
				this.changeState(key, [])
				this.$emit('change', { key: key, value: [] })
				this.$emit('update:modelValue', [])
			}
		} else {
			// Single-select mode
			if (this.selectedValue !== null && this.selectedValue !== Object(this.selectedValue)) {
				// If selectedValue is already the primitive value
				this.changeState(key, this.selectedValue)
				this.$emit('change', { key: key, value: this.selectedValue })
				this.$emit('update:modelValue', this.selectedValue)
			} else if (this.selectedValue !== null) {
				// If selectedValue is an object
				const value = this.selectedValue[valueField]
				this.changeState(key, value)
				this.$emit('change', { key: key, value: value })
				this.$emit('update:modelValue', this.selectedValue)
			} else {
				this.changeState(key, '')
				this.$emit('change', { key: key, value: '' })
				this.$emit('update:modelValue', null)
			}
		}
	}

	clear () {
		const key = this.keyName || 'selectedIds'
		if (this.multiple) {
			this.changeState(key, [])
			this.$emit('change', { key: key, value: [] })
			this.$emit('update:modelValue', [])
		} else {
			this.changeState(key, '')
			this.$emit('change', { key: key, value: '' })
			this.$emit('update:modelValue', null)
		}
	}
}

